import { Injectable } from "@angular/core";
import { DeterminantOperators } from "../constants/finance-constants";
import { DeterminantDetails } from "../models/determinant-details";
import { Rule } from "../models/tariff-rule-set";
import { BehaviorSubject, Subject } from "rxjs";
import { INITIAL_STATE } from "@ngrx/store";
import { Charge } from "../models/charge.interface";

interface TariffState {
  chargeId: string;
  tariffId: string;
  appMode: string;
  routerNavigationAllowed: boolean;
  agreementConfigurationId?: string | null;
}

export const TARIFF_ACTIONS = {
  LIST: "list",
  ADD_NEW: "add-new",
  EDIT: "edit",
  VIEW: "view",
  DELETE: "delete",
  CLONE: "clone",
  GO_BACK: "go-back"
};
export type TariffActions = typeof TARIFF_ACTIONS[keyof typeof TARIFF_ACTIONS];

@Injectable({
  providedIn: 'root'
})
export class TariffService {
  private readonly INITIAL_STATE: TariffState = {
    chargeId: '',
    tariffId: '',
    appMode: '',
    routerNavigationAllowed: true,
    agreementConfigurationId: null
  };

  private _state$ = new BehaviorSubject<TariffState>({...this.INITIAL_STATE});
  private _tariffActionSubject = new Subject<TariffActions>();

  constructor() {}

  readonly tariffActions$ = this._tariffActionSubject.asObservable();
  readonly state$ = this._state$.asObservable();

  emitTariffAction(action: TariffActions): void {
    this._tariffActionSubject.next(action);
  }

  get currentState(): TariffState {
    return this._state$.value;
  }

  updateState(partial: Partial<TariffState>) {
    this._state$.next({ ...this._state$.value, ...partial });
  }

  resetState(){
    this._state$.next(this.INITIAL_STATE);
  }

  getDisplayTextForDeterminant(determinantName: string | undefined, allDeterminants?: DeterminantDetails[]) {
    return allDeterminants?.find(determinant=> determinantName === determinant.name)?.displayName || determinantName;
  }

  getDisplayTextForOperator(operatorValue: string | undefined) {
    if (!operatorValue) return "";

    const operator = Object.values(DeterminantOperators).find(op => op.value === operatorValue);
    return operator ? operator.operator : operatorValue;
  }

  getValuesToPrint(rule: Rule) {
    return rule.values.slice(0, 3).map(value => value.text).join(", ");
  }
}
